var $ = require('jquery');
import cookie from 'js-cookie';

"use strict";

var PLUGIN_NAME = "targitoHandler";

var DEFAULTS = {
  debug: false,		// v debug rezimu se data neodesilaji, jen se zobrazuji v konzoli
  ajaxLoad: false		// identifikace, zda je inicializace pluginu standardni nebo na zaklade dokonceneho ajax pozadavku
};


/**
 * funkce vrati pole objektu sesbiranych dat z elementu s data-targito atributem
 * @returns {[]}
 */
var targitoHandlerGetPageData = function() {
  var pageData = [];
  $('[data-targito]').each(function(){
    pageData.push($(this).data('targito'));
  });
  return pageData;
};

/*
	data-targito data se ulozi do globalni promenne
 */
var targitoHandlerPageData = targitoHandlerGetPageData();
$(document).ajaxStop(function(){
  targitoHandlerPageData = targitoHandlerGetPageData();
});


// plugin constructor
function targitoHandler(element, options) {
  this.element = element;
  this.$me = $(this.element);

  this.options = $.extend(true, {}, DEFAULTS, options);

  this._defaults = DEFAULTS;
  this._name = PLUGIN_NAME;

  this.bindData = {};

  this.ajaxBinded = [];

  this.initialise();

}

/**
 * inicializace
 */
targitoHandler.prototype.initialise = function() {
  var self = this;

  self.bindData = self.$me.data('targito-bind');

  self.bindEvents();
};

/**
 * nabindovani udalosti dle dat objektu z elementu s atributem data-targito-bind
 */
targitoHandler.prototype.bindEvents = function() {
  var self = this,
    object;

  for (var property in self.bindData) {
    if (self.bindData.hasOwnProperty(property)) {
      object = self.bindData[property];

      if ((object.on =='sessionPageLoad') && (typeof(cookie.get('targitoLogin')) == 'undefined')) {
          self.bindEvent('pageLoad', object.action, object.actionValue, object.data);
          cookie.set('targitoLogin', 'true');
      }
      else {
        self.bindEvent(object.on, object.action, object.actionValue, object.data);
      }
    }
  }
};

/**
 * Nabindovani konkretni udalosti na dany objekt
 * @param event: udalost
 * @param action: nazev akce
 * @param actionValue: hodnota akce
 * @param data: vlastni data, ziskana z vychoziho elementu
 */
targitoHandler.prototype.bindEvent = function(event, action, actionValue, data) {
  var self = this,
    $target = self.$me;

  if (((event.indexOf('pageLoad') != -1) && (!self.options.ajaxLoad)) || (event.indexOf('ajaxLoad') != -1)) {

    if ((event.indexOf('pageLoad') != -1) && (!self.options.ajaxLoad)) {
      self.processData(action, actionValue, data);
    }
    else {
      $(document).ajaxStop(function(){
        if (self.ajaxBinded.indexOf(data) == -1) {
          self.ajaxBinded.push(data);
          self.processData(action, actionValue, data);
        }
      });
    }
  }
  else {
    $(window).off(event);
    $(window).on(event, function(e){
      self.processData(action, actionValue, data);
    });
  }
};

/**
 * Zpracovani dat behem udalosti
 * @param action: nazev akce
 * @param actionValue: hodnota akce
 * @param data: vlastni data, ziskana z vychoziho elementu
 */
targitoHandler.prototype.processData = function(action, actionValue, data) {
  var self = this,
    resultData;

  resultData = self.handlePageData(data);
  self.sendDataToTargito(action, actionValue, resultData);
};

/**
 * Zpracovani dat ziskanych ze stranky, v pripade, ze vychozi hodnota klice zacina znakem @, prohleda se objekt dat stranky a nahradi se prislusnou realnou hodnotou
 * @param data: vstupni data objektu
 * @returns {{}}: zpracovana data objektu
 */
targitoHandler.prototype.handlePageData = function(data) {
  var self = this,
    result = {};

  if ($.isArray(data)) {
    result = [];
  }

  if (typeof(data) == 'string') {
    if (data.indexOf('@') == 0) {
      result = self.getPageDataByKey(data);
    }
    else {
      result = data;
    }
  }
  else {
    $.each(data, function (key, value) {
      if (typeof(value) === 'object') {

        if (value === null) {
          result[key] = '';
        }
        else {
          result[key] = self.handlePageData(value);
        }
      }
      else {
        if (value.toString().indexOf('@') == 0) {
          value = self.getPageDataByKey(value);
        }
        result[key] = value;
      }
    });
  }

  return result;
};



/**
 * Pomocna metoda - ziska ze stringu methodName ve tvaru nazevMetody(x) parametr x
 * @param methodName
 * @returns {*}
 */
targitoHandler.prototype.getParamValue = function(methodName) {
  var self = this,
    result = null,
    bracket1 = methodName.indexOf('('),
    bracket2 = methodName.indexOf(')');

  if ((bracket1 != -1) && (bracket2 != -1)) {
    result = methodName.substr(bracket1+1, (bracket2 - bracket1 - 1));

    if (!isNaN(parseInt(result))) {
      result = parseInt(result);
    }
  }

  return result;
};

/**
 * Nahradi klic key za realna data nalezena v globalni promenne targitoHandlerPageData
 * @param key: string, ktery zacina znakem @
 * @returns {string}
 */
targitoHandler.prototype.getPageDataByKey = function(key) {
  var self = this,
    result = '',
    realKey = key.substring(1);

  if (key.indexOf('*') != -1) {
    realKey = realKey.substring(0,realKey.indexOf('*'));
    result = self.getPageDataByKeyPattern(realKey);
  }
  else {
    result = targitoHandlerPageData[realKey];
    result =  self.handlePageData(result);
  }

  if (typeof(result) == 'undefined') {
    result = '';
  }

  return result;
};

/**
 * Nahradi keyPattern za pole objektu nalezenych v globalni promenne targitoHandlerPageData (nalezne vsechny objekty, ktere zacinaji klicem keyPattern)
 * @param keyPattern
 * @returns {Array}
 */
targitoHandler.prototype.getPageDataByKeyPattern = function(keyPattern) {
  var self = this,
    result = [],
    item,
    value;

  for (var key in targitoHandlerPageData) {
    item = targitoHandlerPageData[key];
    value = item[keyPattern];
    if (typeof(value) != 'undefined') {
      result.push(value);
    }
  }

  return result;
};

/**
 * Odesle data do Targito nebo je zobrazi v konzoli
 * @param data
 */
targitoHandler.prototype.sendDataToTargito = function(action, actionValue, data) {
  var self = this,
    targito = window.Targito;

  if (typeof(data) != 'undefined') {
    if (self.options.debug) {
      console.log('Debug rezim - data, ktera by se odeslala do Targito:');
      console.log(`"${action}", "${actionValue}", ${JSON.stringify(data)}`);
    }
    // push dataLayer
    else {

      window.setTimeout(()=>{
        targito = window.Targito;
        if (targito) {
          targito.push(action, actionValue, data);
        }
      },200);

    }
  }
};


/**
 * decide, which methods will be "public"
 */
var API = {
  //collectPageData: targitoHandler.prototype.collectPageData()
};


/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
  var args = arguments;


  return this.each(function() {
    var $this = $(this);

    // get plugin instance
    var plugin = $this.data('plugin_' + PLUGIN_NAME);

    // if there's not, create one
    if (!plugin) {
      plugin = new targitoHandler(this, value);
      $this.data('plugin_' + PLUGIN_NAME, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.targitoHandler.js